import React from "react";

export default function RunningMan() {
  return (
    <div className="runningMan__container">
      <svg
        viewBox="0 0 32 32"
        className="runningMan"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.2 11.3h-6.2l-3.3 4.2-1.9-1.5 4-5.1h7.4z" class="b"></path>
        <path
          d="M7.8 16.3l-2.9-2.3 4.6-5.7h7.7v1.2h-7.1l-3.5 4.4 1 0.7 3.1-3.9h6.5v1.3h-5.9z"
          class="j"
        ></path>
        <path
          d="M22 7.4c0 1.4-1.2 2.6-2.6 2.6s-2.6-1.2-2.6-2.6c0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6z"
          class="b"
        ></path>
        <path
          d="M19.4 10.6c-1.8 0-3.2-1.5-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2 1.8 0 3.2 1.5 3.2 3.2 0.1 1.7-1.4 3.2-3.2 3.2zM19.4 5.3c-1.1 0-2 0.9-2 2s0.9 2 2 2c1.1 0 2-0.9 2-2 0.1-1.1-0.8-2-2-2z"
          class="j"
        ></path>
        <path
          d="M6.6 28.9l-1.7-1.9 5.1-4.4 1-5 2.4 0.4-1.1 5.9z"
          class="b"
        ></path>
        <path
          d="M6.5 29.7l-2.4-2.7 5.4-4.7 1-5.4 3.6 0.7-1.2 6.7-6.4 5.4zM5.8 27.1l0.8 0.9 5.1-4.4 0.9-5.1-1.2-0.2-0.9 4.6-4.7 4.2z"
          class="j"
        ></path>
        <path
          d="M23.2 17.9v-2.5h-4.3v-4.6l-1.7-1.7-5.2 5.3c-0.7 0.7-1.1 1.6-1.1 2.6s0.4 1.9 1.1 2.6l4.1 4.1-0.4 5.5 2.5 0.2 0.4-6.6-4.9-4.9c-0.2-0.2-0.4-0.5-0.4-0.9 0-0.3 0.1-0.6 0.4-0.9l2.8-2.8v4.6h6.7z"
          class="b"
        ></path>
        <path
          d="M18.7 30l-3.7-0.2 0.4-5.9-3.9-3.9c-0.8-0.8-1.3-1.9-1.3-3s0.4-2.2 1.3-3l5.6-5.7 2.4 2.3v4.3h4.3v3.7h-8v-3.7l-1.8 1.8c-0.1 0.1-0.2 0.3-0.2 0.4 0 0.2 0.1 0.3 0.2 0.4l5.1 5.1-0.4 7.4zM16.3 28.6l1.2 0.1 0.4-5.8-4.7-4.7c-0.3-0.3-0.5-0.8-0.5-1.3s0.2-1 0.5-1.3l3.9-3.9v5.5h5.5v-1.2h-4.3v-5l-1.1-1.1-4.8 4.9c-0.6 0.6-0.9 1.4-0.9 2.2s0.3 1.6 0.9 2.2l4.3 4.3-0.4 5.1z"
          class="j"
        ></path>
        <path
          d="M31.7 26.1c0 2-1.7 3.7-3.7 3.7s-3.7-1.7-3.7-3.7c0-2 1.7-3.7 3.7-3.7s3.7 1.7 3.7 3.7z"
          class="i"
        ></path>
        <path d="M3.2 17.9h4.1v1.2h-4.1v-1.2z" class="j"></path>
        <path d="M4.4 20.5h4.1v1.2h-4.1v-1.2z" class="j"></path>
        <path d="M0.5 17.9h1.6v1.2h-1.6v-1.2z" class="j"></path>
        <path d="M22.8 24.7h4.1v1.2h-4.1v-1.2z" class="j"></path>
        <path d="M24 27.3h4.1v1.2h-4.1v-1.2z" class="j"></path>
        <path d="M20 24.7h1.6v1.2h-1.6v-1.2z" class="j"></path>
        <path
          d="M12 5.1c0-0.1 0-0.1 0-0.2 0-0.6-0.5-1.1-1.1-1.1-0.1 0-0.2 0-0.3 0.1-0.1-1.1-1.1-1.9-2.2-1.9-0.2 0-0.3 0-0.5 0-0.5-0.5-1.2-0.9-2-0.9-1.3 0-2.4 0.9-2.7 2.1 0 0 0 0 0 0-0.9 0-1.7 0.8-1.7 1.7 0 0.1 0 0.2 0 0.2h10.5z"
          class="k"
        ></path>
      </svg>
    </div>
  );
}
